import React, { Component } from 'react';
import Select from "react-select";
import { Input } from "reactstrap";
import { Modal, message, Switch } from 'antd';
import axios from "axios";

class ClientModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmLoading: false,
            clientOptions: [],
            valueToChange: null,
        };
        this.handleOk = this.handleOk.bind(this);
        this.getClientOptions = this.getClientOptions.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.associateClient = this.associateClient.bind(this);
    }
    handleOk = () => {
        this.associateClient();
    };
    handleCancel = () => {
        this.props.handleToggleModal(false);
    };
    getClientOptions = async () => {// llamada a opciones
        // try {
        //     if (appointment_id && material_uuid) {
        //         const res = await axios.post(
        //             `https://backoffice.nadu.xyz/api/material-option/getMaterialOptions/`, {//https://backoffice.nadu.xyz
        //             appointment_id: appointment_id,
        //             material_uuid: material_uuid
        //         }
        //         );
        //         if (res.data && res.data.length > 0) {
        //             let formattedData = res.data.map((opcion) => ({
        //                 value: opcion.id,
        //                 label: opcion.name
        //             }))
        //             this.setState({ materialOptions: formattedData })
        //         }
        //     }
        // } catch (error) {
        //     console.log(error)
        // }
    };
    associateClient = async () => {// llamada a confirmar cliente
        this.setState({ confirmLoading: true });
        // try {
        //     const valueToChange = this.state.valueToChange;
        //     let data;
        //     const res = await axios.put(
        //         `ruta`,
        //         { data: data }
        //     );
        //     if (res.status >= 200 && res.status <= 299) {
        //         message.success('Se ha editado el material');
        //     } else {
        //         message.error("Error: No se ha podido modificar el material.");
        //         console.log("Error: ", res)
        //     }
        // } catch (error) {
        //     message.error("Error: No se ha podido modificar el material.");
        //     console.log("Error: ", error)
        // }
        this.setState({ confirmLoading: false });
        this.props.handleToggleModal(false);
    };

    render() {
        const { openModal, contract } = this.props;
        console.log(contract)
        const { confirmLoading } = this.state;
        return (
            <Modal
                title={"Asociando cliente a " + (contract ? contract.titulo : "contrato sin información")}
                open={openModal}
                onOk={this.handleOk}
                centered={true}
                confirmLoading={confirmLoading}
                onCancel={this.handleCancel}
            >
                <Select
                    className="react-select primary"
                    classNamePrefix="react-select"
                    placeholder="Seleccionar valor"
                    name="optionalMaterial_types"
                    isDisabled={confirmLoading}
                    value={this.state.valueToChange}
                    options={this.state.clientOptions}
                    noOptionsMessage={() => "Cargando opciones"}
                    onChange={(value) => this.setState({ valueToChange: value })}
                />
            </Modal>
        );
    }
}

export default ClientModal;



// WEBPACK FOOTER //
// ./src/views/Contracts/ClientModal.jsx